import type { IconProps } from '../types/IconProps.ts';
export const Grid3x3: IconProps = {
    name: 'Grid3x3',
    children: [
        `<path d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM9 3v18M15 3v18M3 9h18M3 15h18" />`,
    ]
};